import { ReactNode, useState } from 'react';
import { Stack } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import equal from 'deep-equal';
import CloseIcon from '@mui/icons-material/Close';

import { QueryParams, SearchableQueryParams } from 'components/FiltersControls/FiltersControls';
import { FiltersSearch } from 'components/FiltersSearch';
import { deleteObjectKeys } from 'utils/deleteObjectKeys';
import { useDispatch } from 'redux/store';
import { Typography } from 'components/Typography/Typography';

import s from './DataTableFilters.module.scss';

export interface DataTableFilter {
  params: SearchableQueryParams;
  setParams: ActionCreatorWithPayload<QueryParams>;
  filtersNode?: ReactNode;
  searchLabel?: string;
  initialParams?: QueryParams;
  onSearch?: (value: string) => void;
}

interface DataTableFiltersProps {
  filters: DataTableFilter;
}

export const DataTableFilters = ({ filters }: DataTableFiltersProps) => {
  const { params, setParams, filtersNode, searchLabel, onSearch, initialParams = {} } = filters;

  const dispatch = useDispatch();

  const [search, setSearch] = useState('');

  const onReset = () => {
    setSearch('');
    dispatch(setParams({ ...initialParamsWithoutPerPage, per_page: perPage }));
  };

  const paramsWithoutPage = deleteObjectKeys(params, ['page']);
  const { per_page: perPage, ...paramsWithoutPerPageAndPage } = paramsWithoutPage;

  const initialParamsWithoutPerPage = deleteObjectKeys(initialParams, ['per_page']);
  const initialParamsWithoutPerPageAndPage = deleteObjectKeys(initialParams, ['per_page', 'page']);

  const hasFilters = !equal(paramsWithoutPerPageAndPage, initialParamsWithoutPerPageAndPage, {
    strict: true,
  });

  return (
    <Stack flexDirection="row" gap="12px">
      {filtersNode}

      {hasFilters && (
        <button className={s.reset} onClick={onReset} type="button">
          <CloseIcon sx={{ width: '18px', fill: '#D32F2F' }} />

          <Typography fontSize="0.8125rem" lineHeight="22px" fontWeight={500} color="#D32F2F">
            Сбросить
          </Typography>
        </button>
      )}

      {onSearch && (
        <FiltersSearch
          search={search}
          searchLabel={searchLabel}
          setSearch={setSearch}
          onSearch={onSearch}
          marginLeft
        />
      )}
    </Stack>
  );
};
